<div class="panel" >
  <h2>Champs supplémentaires</h2>

  <ng-container *ngFor="let field of fields">
    <div class="form-group">
      <label for="field.keys[0]">{{ field.label }}</label>

      <span class="value">{{ field.model.value | empty }}</span>

      <span class="info info-right">
        <ng-container *ngFor="let key of field.fullKeys">
          &nbsp;&nbsp;&nbsp;&nbsp; {{ key }}
        </ng-container>
      </span>
    </div>
  </ng-container>

</div>
